import { useEffect, useState } from "react";
import { getDroplist } from "services";
import { checkResponse } from "helpers/commonFunctions";

// Bộ nhớ cache toàn cục
const droplistCache = new Map();
const listeners = new Map();

export const useDroplistCache = (uuidRef) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!uuidRef) return;

    // Nếu đã có trong cache, trả về luôn
    if (droplistCache.has(uuidRef)) {
      setOptions(droplistCache.get(uuidRef));
      return;
    }

    // Nếu chưa có, gọi API
    const fetchData = async () => {
      try {
        const res = await getDroplist(uuidRef);
        if (checkResponse(res)) {
          const data = res || [];
          droplistCache.set(uuidRef, data);
          setOptions(data);

          // Gọi tất cả listener đang đợi uuidRef này
          listeners.get(uuidRef)?.forEach((cb) => cb(data));
          listeners.delete(uuidRef);
        }
      } catch (e) {
        console.error("Droplist fetch error", e);
      }
    };

    // Nếu đã có listener thì chỉ đăng ký chờ
    if (listeners.has(uuidRef)) {
      listeners.get(uuidRef).push(setOptions);
    } else {
      listeners.set(uuidRef, [setOptions]);
      fetchData();
    }
  }, [uuidRef]);

  return options;
};
